module.exports = __webpack_public_path__ + "static/media/logo-debt.com-whitetext.de90de70.png";